import { Component, OnInit, TemplateRef, ViewChild, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl, UntypedFormArray } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { DatePipe } from '@angular/common';
import * as firebase from 'firebase';
import { MatStepper } from '@angular/material/stepper';
import LocationPicker from 'location-picker';
import { PDFSource } from 'ng2-pdf-viewer';
import Swal from 'sweetalert2';
import { FichaService } from './services/solicitud.services';
import { environment } from 'src/environments/environment.prod';
import { functions } from '../../Helpers/functions';
import { alerts } from '../../Helpers/alerts';
import { data } from './data/unidadesEducativas';
import { dataNivel } from './data/niveles';
import { dataNivelSEK } from './data/niveles';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, last, map, switchMap } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { MapaComponent } from '../mapa/mapa.component';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { Observable } from 'rxjs';
import { element } from 'protractor';

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;


export class Location {
  lat: number;
  lng: number;
  name?: string;
  zoom?: number;
  icon?: string;
}
export class Colegio {
  Codigo: string;
  Latitud: number;
  Longitud: number;
  Direccion: string;
  EsColegio: string;
  SeccionFactura: string;
  LinkContrato: string;
  Colegio: string;
  TiposServicios: string;
  Compania: string;
  TiposServiciosArray: any[];
  HTMLTexto1: String;
  Email_Coordinacion_1: string;
  MuestraFinal: string;
  MuestraRutas: string;
  LinkPDF: string;
  ActivadoFichas: string;
  constructor(Codigo, Colegio, Direccion, Latitud, Longitud, LinkContrato, TiposServicios, HTMLTexto1, Compania, Email_Coordinacion_1, MuestraFinal, LinkPDF, ActivadoFichas, MuestraRutas) {
    this.Codigo = Codigo;
    this.Colegio = Colegio;
    this.Direccion = Direccion;
    this.Latitud = Latitud;
    this.Longitud = Longitud;
    this.LinkContrato = LinkContrato;
    this.TiposServicios = TiposServicios;
    this.HTMLTexto1 = HTMLTexto1;
    this.Compania = Compania;
    this.Email_Coordinacion_1 = Email_Coordinacion_1;
    this.LinkPDF = LinkPDF;
    this.MuestraFinal = MuestraFinal;
    this.ActivadoFichas = ActivadoFichas;
    this.MuestraRutas = MuestraRutas
  }
  getCodigo() {
    return this.Codigo;
  }
  getNombre() {
    return this.Colegio;
  }
  getTiposServicios() {
    this.TiposServiciosArray = [];
    var arrayTipos = this.TiposServicios.split(",");
    arrayTipos.forEach((elemento) => {
      this.TiposServiciosArray.push({ codigo: elemento.split(":")[0], descripcion: elemento.split(":")[1] });
    });
    return this.TiposServiciosArray;
  }
  getContratoLink() {
    return this.LinkContrato;
  }
  getHTMLTexto1() {
    return String(this.HTMLTexto1);
  }
}

@Component({
  selector: 'app-ficha',
  templateUrl: './ficha.component.html',
  styleUrls: ['./ficha.component.css']
})
export class FichaComponent implements OnInit {
  rutaPreestablecida: any = "";
  colegioLatitud: any;
  colegioLongitud: any;

  iconllegada = {
    url: './assets/img/bus.png',
    scaledSize: {
      width: 30,
      height: 30
    }
  }


  iconsalida = {
    url: './assets/img/bus.png',
    scaledSize: {
      width: 30,
      height: 30
    }
  }
  iconColegio = {
    url: './assets/img/d10da071dc61f64c324afcbcfb77d754.png',
    scaledSize: {
      width: 50,
      height: 50
    }
  }


  lat: number = -0.1824411;
  lng: number = -78.4605962;
  points: any[] = [];
  DatosServicioTransporteFormGrou: any;
  message: any;
  formSubmittedUnidad = false;
  dataUnidadEdu = [];
  dataNiveles = [];
  dataNivelesSEK = [];
  latitudRecoijida;
  longitudRecojida;
  unidadEducativa: any;
  latitudDeja;
  longitudDeja;
  operadora!: string;
  uniproParticular: boolean = false;
  uniproFiscales: boolean = false;
  uniproBincentenarios: boolean = false;
  uniproNormales: boolean = false;
  uniproCharlesD: boolean = false;
  cdqMercedezNovoa: boolean = false;
  cdqRoman: boolean = false;
  cdqCotac: boolean = false;
  cdqtodosColegios: boolean = false;
  cdqLuciaToledo: boolean = false;
  uef24deMayo: boolean = false;
  safeSrc: any
  noexisteContrato: boolean = false;
  pdfDefinitionUniproParticulares: any;
  descargaPdfUrl: any;
  finalizarSinContrato = true;
  emailAdmin: string;
  url: any;
  uploadPercent: Observable<number>;
  documento: any;
  downloadURL: Observable<string>;
  profileUrl: Observable<string | null>;
  areaSk: boolean = false;
  areaAllColegios: boolean = false;
  @ViewChild(MapaComponent) child;
  @ViewChild('locationDialog') locationDialog: TemplateRef<any>;
  public estudianteAntiguo: Boolean;
  isLinear = true;
  lp: LocationPicker;
  TiposServiciosArray: any[] = [];
  colegioSeleccionado: Colegio;
  codigoColegioEnviado: string;
  ColegioFormGroup: UntypedFormGroup;
  NuevoAntiguoFormGroup: UntypedFormGroup;
  CIEstudianteFormGroup: UntypedFormGroup;
  DatosEstudianteFormGroup: UntypedFormGroup;
  DireccionDomicilioFormGroup: UntypedFormGroup;
  DatosRepresentanteFormGroup: UntypedFormGroup;
  DatosFacturacionFormGroup: UntypedFormGroup;
  DatosServicioTransporteFormGroup: UntypedFormGroup;
  public tieneRetorno: Boolean;
  public locationDireccion: Location;
  public locationDireccionRegreso: Location;
  base_64_string = 'this_is_where_you_put_base_64';
  pdfSrc: string | PDFSource | ArrayBuffer = '../assets/TERMINOS_Y_CONDICIONES.pdf';
  public loading = false;
  LengthFact: number;
  inicia = false;
  public location: Location;
  public handTool = true;
  public page = 5;
  public pageLabel!: string;
  public rotation: 0 | 90 | 180 | 270 = 0;
  public sidebarVisible = true;
  public spread: 'off' | 'even' | 'odd' = 'off';
  public zoom: number | string = 'auto';
  direccionRetornoP = false;
  verificador = true;
  notificacion = 'Estimado padre de familia, si usted requiere contratar el servicio de transporte escolar para el periodo actual le agradecemos llenar la ficha que se despliega a continuación, según el art. 3, de la normativa del Ministerio de Educación manifiesta que el uso de transporte es libre y voluntario. Recuerde que los pagos son los 10 primeros días de cada mes sin excepción alguna, lea cuidadosamente el contrato adjunto para tomar su decisión personal. La Operadora de transporte garantizará la movilización del estudiantado una vez receptado el contrato para dicha prestación, el cual será direccionado por el Sr. Transportista de manera personal una vez realizadas las verificaciones pertinentes, y este será el único documento habilitante para la prestación del servicio. POR FAVOR ANALICE SU ECONOMÍA ANTES DE SEGUIR CON ESTE PROCESO.';
  cedulaboolean = false;
  rucboolean = false;

  showGif(event: { loaded: number, total: number }) {
    this.loading = event.loaded < event.total;
    //console.log(event.loaded);
  }

  constructor(private service: FichaService,
    private storage: AngularFireStorage,
    private _formBuilder: UntypedFormBuilder,
    public db: AngularFireDatabase,
    private _Activatedroute: ActivatedRoute,
    public datePipe: DatePipe,
    private router: Router) {
  }

  GetMuestraFinal!: string;
  GetLinkPDF!: string;
  MuestraRutas: string;
  resultado: any
  activarFichas: string;
  pointse: any[] = [];
  ngOnInit() {



    this.codigoColegioEnviado = this._Activatedroute.snapshot.paramMap.get("codigoColegioEnviado");
    //console.log("codigoColegioEnviado: "+this.codigoColegioEnviado);
    this.db.object(environment.nodoAmbiente + '/colegios/' + this.codigoColegioEnviado).query.once("value").then((colegioDB: any) => {
      if (colegioDB !== null) {
        var obj = JSON.parse(JSON.stringify(colegioDB));
        //console.log("colegioDB['Codigo']: "+JSON.stringify(objeto.Colegio));
        if (obj !== null && obj['Codigo'] && obj['Codigo'] !== null) {
          this.colegioSeleccionado = new Colegio(obj['Codigo'], obj['Colegio'], obj['Direccion'], obj['Latitud'], obj['Longitud'], obj['LinkContrato'], obj['TiposServicios'], obj['HTMLTexto1'], obj['Compania'], obj['Email_Coordinacion_1'], obj['MuestraFinal'], obj['LinkPDF'], obj['ActivadoFichas'], obj['MuestraRutas']);
          //console.log("Tipos Servicios: "+JSON.stringify(this.colegioSeleccionado.getTiposServicios()));
          this.TiposServiciosArray = this.colegioSeleccionado.getTiposServicios();
          this.operadora = this.colegioSeleccionado.Compania;
          this.unidadEducativa = this.colegioSeleccionado.Codigo;
          this.GetMuestraFinal = this.colegioSeleccionado.MuestraFinal;
          this.GetLinkPDF = this.colegioSeleccionado.LinkPDF;
          this.activarFichas = this.colegioSeleccionado.ActivadoFichas;
          this.MuestraRutas =
            this.colegioSeleccionado.MuestraRutas;
          this.colegioLatitud = obj['Latitud'];
          this.colegioLongitud = obj['Longitud']
          if (this.activarFichas === "SI") {

            if (this.unidadEducativa === 'I') {
              alerts.informationColegioIntisana("", "", "", this.colegioSeleccionado.getHTMLTexto1());
            } else {
              alerts.information("", "", "", this.colegioSeleccionado.getHTMLTexto1());
            }
          }

          if (this.activarFichas === "NO") {
            this.router.navigate(['/']);
            return;
          }

          //email coordinacion
          this.emailAdmin = this.colegioSeleccionado.Email_Coordinacion_1;

          //console.log("Contrato: "+this.sanitizer.bypassSecurityTrustResourceUrl(this.colegioSeleccionado.getContratoLink()));
          this.pdfSrc = this.colegioSeleccionado.getContratoLink();
          this.ColegioFormGroup.patchValue({
            Colegio: obj['Codigo'],
          });



        } else {
          //redireccionar 
          this.router.navigate(['/']);
        }
      }
    });
    this.latitudRecoijida = -0.172216;
    this.longitudRecojida = -78.460953;

    this.latitudDeja = -0.172216;
    this.longitudDeja = -78.460953;
    this.dataUnidadEdu = data;
    this.dataNiveles = dataNivel;
    this.dataNivelesSEK = dataNivelSEK;

    this.ColegioFormGroup = this._formBuilder.group({
      Colegio: ['', Validators.compose([Validators.required])],
      identification: ['', {
        validators: [Validators.required, Validators.minLength(10), Validators.maxLength(20), Validators.pattern("^[0-9 ]*$")]
      }]
    });


    this.DatosEstudianteFormGroup = this._formBuilder.group({
      apellidosCompletos: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      nombresCompletos: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      gradoPromovido: ['', Validators.compose([Validators.required])],
      paralelo: ['', Validators.compose([Validators.required])],
      edad: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],

      callePrincipal: ['', Validators.compose([Validators.required])],
      calleSecundaria: ['', Validators.compose([Validators.required])],
      casaNo: ['', Validators.compose([Validators.required])],
      referencia: ['', Validators.compose([Validators.required])],
      telefonoResidencia: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])],
      sector: ['', Validators.compose([Validators.required])],
    });


    this.DatosRepresentanteFormGroup = this._formBuilder.group({
      ResponsableContratacion: ['', Validators.compose([Validators.required])],
      CedulaRepresentante: ['', {
        validators: [
          Validators.required, Validators.minLength(10),
          Validators.maxLength(20),
          Validators.pattern("^[0-9]*$")]
      }],
      NombreRepresentante: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoCelularRepresentante: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern("^[0-9]*$")])],
      EmailRepresentanteA: ['', Validators.compose([Validators.required, Validators.email])],


      /* CedulaOtroRepresentante: ['', {
         validators: [r
           Validators.required, Validators.minLength(10),
           Validators.maxLength(10),
           Validators.pattern('[\\0-9]*')], asyncValidators: [this.cedula()]
       }],*/
      NombreOtroRepresentante: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoCelularOtroRepresentante: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern("^[0-9]*$")])],
      EmailOtroRepresentante: ['', Validators.compose([Validators.required, Validators.email])],

      ParentescoReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      NombreReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoReferenciaFamiliar: ['', Validators.compose([Validators.minLength(7),
      Validators.maxLength(9), Validators.pattern("^[0-9]*$")])],
      CelularReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.minLength(10),
      Validators.maxLength(10), Validators.pattern("^[0-9]*$")])]

    });



    this.DatosFacturacionFormGroup = this._formBuilder.group({
      TipoDocumento: ['', Validators.compose([Validators.required])],
      CedulaoRuc: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
      NombreFactura: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoFactura: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern("^[0-9]*$")])],

      DireccionFactura: ['', Validators.compose([Validators.required])],
      EmailFactura: ['', Validators.compose([Validators.required, Validators.email])],
    });


    this.DatosServicioTransporteFormGroup = this._formBuilder.group({
      TipoServicioTransporte: ['', Validators.compose([Validators.required])],
      DireccionExacta: ['', Validators.compose([Validators.required])],
      DireccionExactaRetorno: [''],
      ruta: ['', Validators.compose([Validators.required])]
    });


  }

  /*  ************************************ */
  /*  ************************************ */
  /*  *************PRIMER FORM**************** */

  get Colegio() { return this.ColegioFormGroup.controls.Colegio; }
  get identification() { return this.ColegioFormGroup.controls.identification; }

  /*  ************************************ */
  /*  ************************************ */
  /*  *************SEGUNDO FORM**************** */

  get apellidosCompletos() { return this.DatosEstudianteFormGroup.controls.apellidosCompletos; }
  get nombresCompletos() { return this.DatosEstudianteFormGroup.controls.nombresCompletos; }
  get gradoPromovido() { return this.DatosEstudianteFormGroup.controls.gradoPromovido; }
  get paralelo() { return this.DatosEstudianteFormGroup.controls.paralelo; }
  get edad() { return this.DatosEstudianteFormGroup.controls.edad; }
  get callePrincipal() { return this.DatosEstudianteFormGroup.controls.callePrincipal; }
  get calleSecundaria() { return this.DatosEstudianteFormGroup.controls.calleSecundaria; }
  get casaNo() { return this.DatosEstudianteFormGroup.controls.casaNo; }
  get referencia() { return this.DatosEstudianteFormGroup.controls.referencia; }
  get telefonoResidencia() { return this.DatosEstudianteFormGroup.controls.telefonoResidencia; }
  get sector() { return this.DatosEstudianteFormGroup.controls.sector; }



  /*  ************************************ */
  /*  ************************************ */
  /*  *************TERCER FORM**************** */

  get ResponsableContratacion() { return this.DatosRepresentanteFormGroup.controls.ResponsableContratacion; }
  get CedulaRepresentante() { return this.DatosRepresentanteFormGroup.controls.CedulaRepresentante; }
  get NombreRepresentante() { return this.DatosRepresentanteFormGroup.controls.NombreRepresentante; }
  get TelefonoCelularRepresentante() { return this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante; }
  get EmailRepresentanteA() { return this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA; }

  get NombreOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante; }
  get TelefonoCelularOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante; }
  get EmailOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante; }

  get NombreReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar; }
  get TelefonoReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar; }
  get CelularReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar; }
  get ParentescoReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar; }


  /*  ************************************ */
  /*  ************************************ */
  /*  *************CUARTO FORM FACTURACION**************** */

  get TipoDocumento() { return this.DatosFacturacionFormGroup.controls.TipoDocumento; }
  get CedulaoRuc() { return this.DatosFacturacionFormGroup.controls.CedulaoRuc; }
  get NombreFactura() { return this.DatosFacturacionFormGroup.controls.NombreFactura; }

  get TelefonoFactura() { return this.DatosFacturacionFormGroup.controls.TelefonoFactura; }

  get DireccionFactura() { return this.DatosFacturacionFormGroup.controls.DireccionFactura; }
  get EmailFactura() { return this.DatosFacturacionFormGroup.controls.EmailFactura; }



  /*  ************************************ */
  /*  ************************************ */
  /*  *************QUINTO FORM MAPAS**************** */

  get TipoServicioTransporte() { return this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte; }
  get DireccionExacta() { return this.DatosServicioTransporteFormGroup.controls.DireccionExacta; }
  get DireccionExactaRetorno() { return this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno; }
  get ruta() { return this.DatosServicioTransporteFormGroup.controls.ruta }
  //


  seleccionTipoDocFact(event: any) {

    if (event === 'Cédula') {
      this.LengthFact = 10;
    } else if (event === 'RUC') {
      this.LengthFact = 13;
    }
  }

  checkValue(event: any) {
    this.estudianteAntiguo = event;
  }

  onToggleChange(event: any) {
    this.estudianteAntiguo = event;
  }

  get EmailRepresentante() {
    return this.DatosRepresentanteFormGroup.get('EmailRepresentante');
  }


  seleccionTipo: boolean = false;
  tiposervicio: string = ""
  cambioTipoServicio(TipoServicio: string) {
    this.tiposervicio = TipoServicio;
    alerts.informationmapHelp();
    if (this.MuestraRutas == "NO") {
      if (TipoServicio) {
        this.mostrarCamposPaso4 = true;
      }
      //  console.log("ENTRA AQUI CAMBIO: " + this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value)
      if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value == 'DOBLE RUTA') {
        //  this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.reset()
        // IOR: Se aniade el validador cuando es doble ruta
        this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.setValidators(Validators.compose([Validators.required]));
        ////DireccionExacta: ['', Validators.compose([Validators.required])],
        ///DireccionExactaRetorno: [''], 

        this.tieneRetorno = true;
      } else {
        // IOR: Si no es doble ruta se quita el validador
        this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.clearValidators();
        this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value == ''
        this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.updateValueAndValidity();
        this.tieneRetorno = false;
        this.locationDireccionRegreso = null;
      }
      this.seleccionTipo = false;
    }
    if (this.MuestraRutas == "SI") {
      this.seleccionTipo = true;
    }

  }

  locationDireccionChange(location: Location) {
    this.locationDireccion = location;
    this.latitudRecoijida = location["lat"];
    this.longitudRecojida = location["lng"];

    //   this.DatosServicioTransporteFormGroup.controls['CoordenadasForm'].setErrors({ 'incorrect': false });
    //   this.DatosServicioTransporteFormGroup.get('CoordenadasForm').setValue(JSON.stringify(location));
  }

  locationDireccionRetornoChange(location: Location) {
    this.locationDireccionRegreso = location;
    this.latitudDeja = location["lat"];
    this.longitudDeja = location["lng"];

  }

  helperMap(){
    alerts.informationmapHelp();
  }

  mostrarCamposPaso4: boolean = false;

  goForward(stepper: MatStepper) {
    let paso = stepper.selectedIndex;
    //console.log("paso: "+paso);
    //console.log("this.MuestraRutas: "+this.MuestraRutas);
    /////PASO 0
    if (this.ColegioFormGroup.status == "VALID" && paso == 0) {
      const colegio = this.ColegioFormGroup.controls.Colegio.value;
      const cedula = (this.ColegioFormGroup.controls.identification.value);
      var cedulaEspacios = cedula.split(" ").join("");
      this.ColegioFormGroup.controls.identification.setValue(cedulaEspacios)
      this.service.getdata(colegio, cedulaEspacios).subscribe((resp: any) => {
        if (resp) {
          alerts.basicAlert("Actualice sus datos", "Estudiante existente", "info");
          this.DatosEstudianteFormGroup.controls.apellidosCompletos.setValue(resp.DatosEstudiante.ApellidosCompletos);
          this.DatosEstudianteFormGroup.controls.nombresCompletos.setValue(resp.DatosEstudiante.NombresCompletos);
          //this.DatosEstudianteFormGroup.controls.paralelo.setValue(resp.DatosEstudiante.Paralelo);
          //this.DatosEstudianteFormGroup.controls.gradoPromovido.setValue(resp.DatosEstudiante.GradoPromovido);
          this.DatosEstudianteFormGroup.controls.edad.setValue(resp.DatosEstudiante.Edad);

          this.DatosEstudianteFormGroup.controls.callePrincipal.setValue(resp.DireccionDomicilio.CallePrincipal);
          this.DatosEstudianteFormGroup.controls.calleSecundaria.setValue(resp.DireccionDomicilio.CalleSecundaria);
          this.DatosEstudianteFormGroup.controls.casaNo.setValue(resp.DireccionDomicilio.CasaNo);
          this.DatosEstudianteFormGroup.controls.referencia.setValue(resp.DireccionDomicilio.Referencia);
          this.DatosEstudianteFormGroup.controls.telefonoResidencia.setValue(resp.DireccionDomicilio.TelefonoResidencia);
          this.DatosEstudianteFormGroup.controls.sector.setValue(resp.DireccionDomicilio.Sector);

          this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.setValue(resp.DatosRepresentante.ResponsableContratacion);
          this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.setValue(resp.DatosRepresentante.CedulaRepresentante);
          this.DatosRepresentanteFormGroup.controls.NombreRepresentante.setValue(resp.DatosRepresentante.NombreRepresentante);
          this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.setValue(resp.DatosRepresentante.TelefonoCelularRepresentante);
          this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.setValue(resp.DatosRepresentante.EmailRepresentante);

          this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.setValue(resp.DatosRepresentante.NombreOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.setValue(resp.DatosRepresentante.TelefonoCelularOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.setValue(resp.DatosRepresentante.EmailOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.setValue(resp.DatosRepresentante.CelularReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.setValue(resp.DatosRepresentante.NombreReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.setValue(resp.DatosRepresentante.ParentescoReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.setValue(resp.DatosRepresentante.TelefonoReferenciaFamiliar);

          this.DatosFacturacionFormGroup.controls.TipoDocumento.setValue(resp.DatosFacturacion.TipoDocumento);
          this.DatosFacturacionFormGroup.controls.CedulaoRuc.setValue(resp.DatosFacturacion.CedulaoRuc);
          this.DatosFacturacionFormGroup.controls.NombreFactura.setValue(resp.DatosFacturacion.NombreFactura);
          this.DatosFacturacionFormGroup.controls.TelefonoFactura.setValue(resp.DatosFacturacion.TelefonoFactura);
          this.DatosFacturacionFormGroup.controls.DireccionFactura.setValue(resp.DatosFacturacion.DireccionFactura);
          this.DatosFacturacionFormGroup.controls.EmailFactura.setValue(resp.DatosFacturacion.EmailFactura);
        } else {
          this.DatosEstudianteFormGroup.reset();
          this.DatosRepresentanteFormGroup.reset();
          this.DatosFacturacionFormGroup.reset();
        }
      });
    }

    /////PASO 3
    if (paso == 3 && this.ColegioFormGroup.status == "VALID" && this.MuestraRutas == "NO") {
      //alerts.informationmap();
    }
    /////Empieza rutas predefinida
    if (this.MuestraRutas == "SI") {
      if (paso == 3 && this.ColegioFormGroup.status == "VALID") {
        this.rutaPreestablecida = "";
        this.points = [];
        this.service.getRutasInscripcionByColegio(this.codigoColegioEnviado).subscribe(resp => {
          Object.keys(resp).forEach(key => {
            const element = JSON.parse(resp[key].coordenadas);
            const nombreRuta = resp[key].ruta + "-" + resp[key].descripcion;
            this.points.push({ element, nombreRuta, key });
          });
        });

      }

      if (paso == 4) {
        if (this.rutasSelecinadas == undefined && this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {
          return;
        }
        if (this.rutasSelecinadas.length != 2 && this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {
          alerts.basicAlert("Por favor seleccione 2 rutas", "", "error");
          return;
        }
        if (this.rutaPreestablecida == "" && this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value !== 'DOBLE RUTA') {
          alerts.basicAlert("Por favor seleccione una ruta", "", "error");
          return;
        }
        if (this.rutaPreestablecida != "" || this.rutasSelecinadas.length == 2) {
          this.DatosServicioTransporteFormGroup.controls.DireccionExacta.setValue(" ");
          this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.setValue(" ");
        }
      }

      if (paso == 4 && this.DatosServicioTransporteFormGroup.status == "VALID") {
        this.guardarDatos();
        let timerInterval;
        Swal.fire({
          title: 'Por favor, Espere un momento',
          html: 'Estamos procesando su solicitud.',
          timer: 4000,
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()

            timerInterval = setInterval(() => {
              (Swal.getTimerLeft())
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          if (this.GetMuestraFinal === "VACIO") {
            if (this.unidadEducativa === "VM" || this.unidadEducativa === "VME") {
              var texto = "";
            } else {
              var texto = "Pronto nos pondremos en contacto con usted.";
            }
            Swal.fire({
              title: 'Su solicitud de transporte se ha registrado exitosamente.',
              text: texto,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Aceptar'
            }).then((result) => {
              window.location.href = "/gracias";

            });
            this.finalizarSinContrato = false;
          }
          this.envioServicio();
          this.createPdf();
          //BAYARDO
          stepper.next();
          if (this.GetMuestraFinal === "CONTRATO") {
            Swal.fire({
              title: 'Finalizando solicitud.',
              timer: 2500,
              timerProgressBar: true,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
                timerInterval = setInterval(() => {
                  (Swal.getTimerLeft())
                }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
              }
            }).then((result) => { })
          }
        })
      }

      stepper.next();
    } else {
      this.DatosServicioTransporteFormGroup.controls.ruta.setValue(" ");
      if (paso == 4 && this.latitudRecoijida == -0.172216 && this.longitudRecojida == -78.460953 && this.mostrarCamposPaso4 == true) {
        alerts.informationmapHelp();
        return;
      }
      if (paso == 4 && this.mostrarCamposPaso4 == false) {
        alerts.basicAlert("Seleccione tipo de servicio transporte.", "Para continuar despliege y seleccione una opción.", "info");
        return
      }
      if (paso == 4) {
        if (this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value == "") {
          this.direccionRetornoP = false;
          alerts.basicAlert("Complete correctamente la información.", "Para continuar, ingrese todos los datos solicitados. (Error: 687)", "info")
          return;
        }
      }
      if (paso == 4 && this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value == "DOBLE RUTA" && this.mostrarCamposPaso4 == true) {
        if (paso == 4 && this.latitudDeja == -0.172216 && this.longitudDeja == -78.460953) {
          //console.log("ENTRA AQUI 5")
          alerts.informationmapHelp();
          return;
        }
        if (this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value != "") {
          this.direccionRetornoP = false;


        }
        else {
          alerts.basicAlert("Complete correctamente la información.", "Para continuar, ingrese los datos solicitados. (Error: 703)", "info")

          this.direccionRetornoP = true; return;
        }
        if (paso == 4 && this.direccionRetornoP == false) {
          this.guardarDatos();
        }
      } else {
        this.direccionRetornoP = false;
        if (paso == 4 && this.direccionRetornoP == false) {
          this.guardarDatos();
        }
      }

      if (paso == 4 && this.DatosServicioTransporteFormGroup.status != "VALID") {
        console.log(this.DatosServicioTransporteFormGroup)
        alerts.basicAlert("Complete correctamente la información.", "Para continuar, ingrese todos los datos solicitados. (Error: 719)", "info")
      }
      if (paso == 4 && this.DatosServicioTransporteFormGroup.status == "VALID") {
        let timerInterval;
        Swal.fire({
          title: 'Por favor, Espere un momento',
          html: 'Estamos procesando su solicitud.',
          timer: 4000,
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
            timerInterval = setInterval(() => {
              (Swal.getTimerLeft())
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          if (this.GetMuestraFinal === "VACIO") {
            if (this.unidadEducativa === "VM" || this.unidadEducativa === "VME") {
              var texto = "";
            } else {
              var texto = "Pronto nos pondremos en contacto con usted.";
            }

            Swal.fire({
              title: 'Su solicitud de transporte se ha registrado exitosamente.',
              text: texto,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Aceptar'
            }).then((result) => {
              window.location.href = "/gracias";

            });
            this.finalizarSinContrato = false;
          }

          this.envioServicio();
          this.createPdf();
          //BAYARDO

          stepper.next();
          if (this.GetMuestraFinal === "CONTRATO") {
            Swal.fire({
              title: 'Finalizando solicitud.',
              timer: 2500,
              timerProgressBar: true,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
                timerInterval = setInterval(() => {
                  (Swal.getTimerLeft())
                }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
              }
            }).then((result) => { })
          }
        })
      } else {
        stepper.next();
      }
    }

    if (stepper.selectedIndex === 5) {
      if (this.DatosFacturacionFormGroup.invalid) {
        return;
      }
    }


  }

  nombreRepresentante: string;
  cedulaRepresentante: string;
  nombresEstudiante: string;
  cedulaEstudiante: string;
  apellidosEstudiante: string;
  gradoyParalelo: string;
  direccionExacta: string;
  direccionRetorno: string;
  telefonoCelularRepresentanteManiana: string;
  telefonoCelularRepresentanteTarde: string;
  responsableContratacion: string;
  telefonoCelularRepresentante: string;
  nombresResponsableMadre: string;
  emailResponsableMadre: string;
  telefonoResponsableMadre: string;
  nombresResponsablePadre: string;
  emailResponsablePadre: string;
  telefonoResponsablePadre: string;
  nombreContactoEmergencia: string;
  emailContactoEmergencia: string;
  telefonoContactoEmergencia: string;
  valorAPagar: string;
  tipoServicio: string;
  anio: any;
  mes: any;
  dia: any;
  fileRef: any;
  task: any;
  almacenoInformacionBD: boolean = false;

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  public guardarDatos() {
    /************************* */
    /**** ESTRUCURAR DATA FICHAAAA ****/
    var colegio = this.unidadEducativa;
    var cedula = this.ColegioFormGroup.controls.identification.value;
    var refString = environment.nodoAmbiente + '/fichas/' + colegio + '/' + cedula;






    if (this.MuestraRutas == "SI") {


      this.service.getRutasByColegioAndRutas(colegio).subscribe(resp => {
        for (let index = 0; index < resp.length; index++) {
          const element = resp[index];
          this.service.deletealumnoByCedula(colegio, element, cedula);
        }

        var dataRef = this.db.object(refString + '/IdentificacionAlumno');
        dataRef.set({ CIEstudiante: cedula });
        var dataRef = this.db.object(refString + '/FechaGuarda');
        dataRef.set(firebase.default.database['ServerValue']['TIMESTAMP']);
        var dataRef = this.db.object(refString + '/DatosEstudiante');

        dataRef.set(
          {
            ApellidosCompletos: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value,
            NombresCompletos: this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
            GradoPromovido: this.DatosEstudianteFormGroup.controls.gradoPromovido.value,
            Paralelo: this.DatosEstudianteFormGroup.controls.paralelo.value,
            Edad: this.DatosEstudianteFormGroup.controls.edad.value
          });


        var dataRef = this.db.object(refString + '/DireccionDomicilio');
        dataRef.set(
          {
            CallePrincipal: this.DatosEstudianteFormGroup.controls.callePrincipal.value,
            CalleSecundaria: this.DatosEstudianteFormGroup.controls.calleSecundaria.value,
            CasaNo: this.DatosEstudianteFormGroup.controls.casaNo.value,
            Referencia: this.DatosEstudianteFormGroup.controls.referencia.value,
            Sector: this.DatosEstudianteFormGroup.controls.sector.value,
            TelefonoResidencia: this.DatosEstudianteFormGroup.controls.telefonoResidencia.value
          }
        );



        if (this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value) {
          var NombreOtroRepresentante = this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value;
        } else {
          NombreOtroRepresentante = "";
        }


        if (this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value) {
          var TelefonoCelularOtroRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value;
        } else {
          TelefonoCelularOtroRepresentante = "";
        }



        if (this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value) {
          var EmailOtroRepresentante = this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value;
        } else {
          EmailOtroRepresentante = "";
        }
        var telefonoRefRepresentante = ""
        if (this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value != undefined) {
          telefonoRefRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value
        }
        var dataRefD = this.db.object(refString + '/DatosRepresentante');
        dataRefD.set({
          ResponsableContratacion: this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.value,
          CedulaRepresentante: this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.value,
          NombreRepresentante: this.DatosRepresentanteFormGroup.controls.NombreRepresentante.value,
          TelefonoCelularRepresentante: this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.value,
          EmailRepresentante: this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.value,


          NombreOtroRepresentante: NombreOtroRepresentante,
          TelefonoCelularOtroRepresentante: TelefonoCelularOtroRepresentante,
          EmailOtroRepresentante: EmailOtroRepresentante,
          CelularReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.value,
          NombreReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.value,
          ParentescoReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.value,
          TelefonoReferenciaFamiliar: telefonoRefRepresentante
        });



        var dataRef = this.db.object(refString + '/DatosFacturacion');
        dataRef.set({
          CedulaoRuc: this.DatosFacturacionFormGroup.controls.CedulaoRuc.value,
          DireccionFactura: this.DatosFacturacionFormGroup.controls.DireccionFactura.value,
          EmailFactura: this.DatosFacturacionFormGroup.controls.EmailFactura.value,
          NombreFactura: this.DatosFacturacionFormGroup.controls.NombreFactura.value,
          TelefonoFactura: this.DatosFacturacionFormGroup.controls.TelefonoFactura.value,
          TipoDocumento: this.DatosFacturacionFormGroup.controls.TipoDocumento.value
        });


        if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {



          if (this.MuestraRutas == 'SI') {

            alerts.basicAlert("No establecido para doble ruta", "", "info");
            return
            var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
            dataRefegreso.set({
              DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
              DireccionExactaRetorno: this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value,
              TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
              rutaPreAsignada: JSON.stringify(this.rutasSelecinadas)
            });
          }

          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
          dataRefegreso.set({
            lng: this.longitudRecojida,
            lat: this.latitudRecoijida,
            zoom: 16
          });

          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
          dataRefegreso.set({
            lng: this.longitudDeja,
            lat: this.latitudDeja,
            zoom: 16
          });
        }


        else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO ENTRADA') {

      
          if (this.MuestraRutas == 'SI') {
            var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
            dataRefegreso.set({
              TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
              DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
              rutaPreAsignada: JSON.stringify([this.rutaPreestablecida])
            });





            var refUpdate = this.db.object(environment.nodoAmbiente + '/rutasAlumnos/' + this.ColegioFormGroup.controls.Colegio.value + '/' + this.rutaPreestablecida + '/alumnos/' + cedula);

            refUpdate.update({

              nombreEstudiante: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value + " " + this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
              tipoMarker: "entrada"

            });

          }


          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
          dataRefegreso.set({
            lng: this.longitudRecojida,
            lat: this.latitudRecoijida,
            zoom: 16
          });

          this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
        }
        else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'COMPLETO') {



        

          if (this.MuestraRutas == 'SI') {

            var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
            dataRefegreso.set({
              TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
              DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
              rutaPreAsignada: JSON.stringify([this.rutaPreestablecida])

            });



            var refUpdate = this.db.object(environment.nodoAmbiente + '/rutasAlumnos/' + this.ColegioFormGroup.controls.Colegio.value + '/' + this.rutaPreestablecida + '/alumnos/' + cedula);

            refUpdate.update({

              nombreEstudiante: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value + " " + this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
              tipoMarker: "entrada/salida"

            })

            
          }


          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
          dataRefegreso.set({
            lng: this.longitudRecojida,
            lat: this.latitudRecoijida,
            zoom: 16
          });
          this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
        }


        else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO SALIDA') {


      

          if (this.MuestraRutas == 'SI') {
            var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
            dataRefegreso.set({
              TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
              DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
              rutaPreAsignada: JSON.stringify([this.rutaPreestablecida])
            });



            var refUpdate = this.db.object(environment.nodoAmbiente + '/rutasAlumnos/' + this.ColegioFormGroup.controls.Colegio.value + '/' + this.rutaPreestablecida + '/alumnos/' + cedula);

            refUpdate.update({

              nombreEstudiante: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value + " " + this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
              tipoMarker: "salida"

            });

          }


          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
          dataRefegreso.set({ lng: this.longitudRecojida, lat: this.latitudRecoijida, zoom: 16 });
          this.db.object(refString + '/DatosServicioTransporte/Coordenadas').remove();
        }



      });








    } else {

      var dataRef = this.db.object(refString + '/IdentificacionAlumno');
      dataRef.set({ CIEstudiante: cedula });
      var dataRef = this.db.object(refString + '/FechaGuarda');
      dataRef.set(firebase.default.database['ServerValue']['TIMESTAMP']);
      var dataRef = this.db.object(refString + '/DatosEstudiante');

      dataRef.set(
        {
          ApellidosCompletos: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value,
          NombresCompletos: this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
          GradoPromovido: this.DatosEstudianteFormGroup.controls.gradoPromovido.value,
          Paralelo: this.DatosEstudianteFormGroup.controls.paralelo.value,
          Edad: this.DatosEstudianteFormGroup.controls.edad.value
        });


      var dataRef = this.db.object(refString + '/DireccionDomicilio');
      dataRef.set(
        {
          CallePrincipal: this.DatosEstudianteFormGroup.controls.callePrincipal.value,
          CalleSecundaria: this.DatosEstudianteFormGroup.controls.calleSecundaria.value,
          CasaNo: this.DatosEstudianteFormGroup.controls.casaNo.value,
          Referencia: this.DatosEstudianteFormGroup.controls.referencia.value,
          Sector: this.DatosEstudianteFormGroup.controls.sector.value,
          TelefonoResidencia: this.DatosEstudianteFormGroup.controls.telefonoResidencia.value
        }
      );



      if (this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value) {
        var NombreOtroRepresentante = this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value;
      } else {
        NombreOtroRepresentante = "";
      }


      if (this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value) {
        var TelefonoCelularOtroRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value;
      } else {
        TelefonoCelularOtroRepresentante = "";
      }



      if (this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value) {
        var EmailOtroRepresentante = this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value;
      } else {
        EmailOtroRepresentante = "";
      }
      var telefonoRefRepresentante = ""
      if (this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value != undefined) {
        telefonoRefRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value
      }
      var dataRefD = this.db.object(refString + '/DatosRepresentante');
      dataRefD.set({
        ResponsableContratacion: this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.value,
        CedulaRepresentante: this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.value,
        NombreRepresentante: this.DatosRepresentanteFormGroup.controls.NombreRepresentante.value,
        TelefonoCelularRepresentante: this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.value,
        EmailRepresentante: this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.value,


        NombreOtroRepresentante: NombreOtroRepresentante,
        TelefonoCelularOtroRepresentante: TelefonoCelularOtroRepresentante,
        EmailOtroRepresentante: EmailOtroRepresentante,
        CelularReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.value,
        NombreReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.value,
        ParentescoReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.value,
        TelefonoReferenciaFamiliar: telefonoRefRepresentante
      });



      var dataRef = this.db.object(refString + '/DatosFacturacion');
      dataRef.set({
        CedulaoRuc: this.DatosFacturacionFormGroup.controls.CedulaoRuc.value,
        DireccionFactura: this.DatosFacturacionFormGroup.controls.DireccionFactura.value,
        EmailFactura: this.DatosFacturacionFormGroup.controls.EmailFactura.value,
        NombreFactura: this.DatosFacturacionFormGroup.controls.NombreFactura.value,
        TelefonoFactura: this.DatosFacturacionFormGroup.controls.TelefonoFactura.value,
        TipoDocumento: this.DatosFacturacionFormGroup.controls.TipoDocumento.value
      });


      if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {


        if (this.MuestraRutas == 'NO') {
          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
          dataRefegreso.set({
            DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
            DireccionExactaRetorno: this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value,
            TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
          });
        }



        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        });

        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
        dataRefegreso.set({
          lng: this.longitudDeja,
          lat: this.latitudDeja,
          zoom: 16
        });
      }


      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO ENTRADA') {

        if (this.MuestraRutas == 'NO') {
          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
          dataRefegreso.set({
            TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
            DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

          });
        }


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        });

        this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
      }
      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'COMPLETO') {



        if (this.MuestraRutas == 'NO') {
          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
          dataRefegreso.set({
            TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
            DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,


          });

        }




        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        });
        this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
      }


      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO SALIDA') {


        if (this.MuestraRutas == 'NO') {
          var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
          dataRefegreso.set({
            TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
            DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
          });
        }



        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
        dataRefegreso.set({ lng: this.longitudRecojida, lat: this.latitudRecoijida, zoom: 16 });
        this.db.object(refString + '/DatosServicioTransporte/Coordenadas').remove();
      }




    }

















    /******************************************
       * ALMACENA EN HISTORICO
       */

    var colegio = this.unidadEducativa;
    var cedula = this.ColegioFormGroup.controls.identification.value;
    var refString = environment.nodoAmbiente + '/fichasHistoricas/' + colegio + '/' + cedula;

    var dataRef = this.db.object(refString + '/IdentificacionAlumno');
    dataRef.set({ CIEstudiante: cedula });
    var dataRef = this.db.object(refString + '/FechaGuarda');
    dataRef.set(firebase.default.database['ServerValue']['TIMESTAMP']);
    var dataRef = this.db.object(refString + '/DatosEstudiante');

    dataRef.set(
      {
        ApellidosCompletos: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value,
        NombresCompletos: this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
        GradoPromovido: this.DatosEstudianteFormGroup.controls.gradoPromovido.value,
        Paralelo: this.DatosEstudianteFormGroup.controls.paralelo.value,
        Edad: this.DatosEstudianteFormGroup.controls.edad.value
      });






    var dataRef = this.db.object(refString + '/DireccionDomicilio');
    dataRef.set(
      {
        CallePrincipal: this.DatosEstudianteFormGroup.controls.callePrincipal.value,
        CalleSecundaria: this.DatosEstudianteFormGroup.controls.calleSecundaria.value,
        CasaNo: this.DatosEstudianteFormGroup.controls.casaNo.value,
        Referencia: this.DatosEstudianteFormGroup.controls.referencia.value,
        Sector: this.DatosEstudianteFormGroup.controls.sector.value,
        TelefonoResidencia: this.DatosEstudianteFormGroup.controls.telefonoResidencia.value
      }
    );



    if (this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value) {
      var NombreOtroRepresentante = this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value;
    } else {
      NombreOtroRepresentante = "";
    }


    if (this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value) {
      var TelefonoCelularOtroRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value;
    } else {
      TelefonoCelularOtroRepresentante = "";
    }



    if (this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value) {
      var EmailOtroRepresentante = this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value;
    } else {
      EmailOtroRepresentante = "";
    }


    var telefonoRefRepresentante = ""
    if (this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value != undefined) {
      telefonoRefRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value
    }

    var dataRefD = this.db.object(refString + '/DatosRepresentante');
    dataRefD.set({
      ResponsableContratacion: this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.value,
      CedulaRepresentante: this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.value,
      NombreRepresentante: this.DatosRepresentanteFormGroup.controls.NombreRepresentante.value,
      TelefonoCelularRepresentante: this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.value,
      EmailRepresentante: this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.value,


      NombreOtroRepresentante: NombreOtroRepresentante,
      TelefonoCelularOtroRepresentante: TelefonoCelularOtroRepresentante,
      EmailOtroRepresentante: EmailOtroRepresentante,
      CelularReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.value,
      NombreReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.value,
      ParentescoReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.value,
      TelefonoReferenciaFamiliar: telefonoRefRepresentante,
    });



    var dataRef = this.db.object(refString + '/DatosFacturacion');
    dataRef.set({
      CedulaoRuc: this.DatosFacturacionFormGroup.controls.CedulaoRuc.value,
      DireccionFactura: this.DatosFacturacionFormGroup.controls.DireccionFactura.value,
      EmailFactura: this.DatosFacturacionFormGroup.controls.EmailFactura.value,
      NombreFactura: this.DatosFacturacionFormGroup.controls.NombreFactura.value,
      TelefonoFactura: this.DatosFacturacionFormGroup.controls.TelefonoFactura.value,
      TipoDocumento: this.DatosFacturacionFormGroup.controls.TipoDocumento.value
    });


    if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {
      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
      dataRefegreso.set({
        DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
        DireccionExactaRetorno: this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value,
        TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
      });


      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
      dataRefegreso.set({
        lng: this.longitudRecojida,
        lat: this.latitudRecoijida,
        zoom: 16
      });

      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
      dataRefegreso.set({
        lng: this.longitudDeja,
        lat: this.latitudDeja,
        zoom: 16
      });
    }


    else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO ENTRADA') {
      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
      dataRefegreso.set({
        TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
        DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

      });


      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
      dataRefegreso.set({
        lng: this.longitudRecojida,
        lat: this.latitudRecoijida,
        zoom: 16
      });

      this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
    }
    else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'COMPLETO') {


      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
      dataRefegreso.set({
        TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
        DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

      });


      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
      dataRefegreso.set({
        lng: this.longitudRecojida,
        lat: this.latitudRecoijida,
        zoom: 16
      });
      this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
    }


    else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO SALIDA') {
      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
      dataRefegreso.set({
        TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
        DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
      });



      var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
      dataRefegreso.set({ lng: this.longitudRecojida, lat: this.latitudRecoijida, zoom: 16 });
      this.db.object(refString + '/DatosServicioTransporte/Coordenadas').remove();
    }





    var colegio = this.ColegioFormGroup.controls.Colegio.value;
    var cedula = this.ColegioFormGroup.controls.identification.value;

    this.service.getFichaByColegioAndCedula(colegio, cedula).subscribe(resp => {
      if (resp != undefined || resp == null) {

        /******representante */
        this.nombreRepresentante = resp.DatosRepresentante['NombreRepresentante'];
        this.cedulaRepresentante = resp.DatosRepresentante['CedulaRepresentante'];
        this.telefonoCelularRepresentante = resp.DatosRepresentante['TelefonoCelularRepresentante'];



        /******estudiante */
        this.nombresEstudiante = resp.DatosEstudiante['NombresCompletos'];
        this.cedulaEstudiante = resp.IdentificacionAlumno['CIEstudiante'];
        this.apellidosEstudiante = resp.DatosEstudiante['ApellidosCompletos'];
        this.gradoyParalelo = resp.DatosEstudiante['GradoPromovido'] + " " + resp.DatosEstudiante['Paralelo'];


        if (resp.DatosServicioTransporte['TipoServicioTransporte'] == "COMPLETO" || resp.DatosServicioTransporte['TipoServicioTransporte'] == "OPCIONAL SOLO ENTRADA" || resp.DatosServicioTransporte['TipoServicioTransporte'] == "DOBLE RUTA") {

          if (resp.DatosServicioTransporte['TipoServicioTransporte'] == "OPCIONAL SOLO ENTRADA") {
            this.direccionRetorno = "";
            this.telefonoCelularRepresentanteTarde = "";
          }
          this.telefonoCelularRepresentanteManiana = resp.DatosRepresentante['TelefonoCelularRepresentante'];
          this.direccionExacta = resp.DatosServicioTransporte['DireccionExacta']
        }


        if (resp.DatosServicioTransporte['TipoServicioTransporte'] == "COMPLETO" || resp.DatosServicioTransporte['TipoServicioTransporte'] == "OPCIONAL SOLO SALIDA" || resp.DatosServicioTransporte['TipoServicioTransporte'] == "DOBLE RUTA") {
          if (resp.DatosServicioTransporte['TipoServicioTransporte'] == "COMPLETO") {
            this.direccionRetorno = resp.DatosServicioTransporte['DireccionExacta']
          } else {
            this.direccionRetorno = resp.DatosServicioTransporte['DireccionExactaRetorno']
          }
          if (resp.DatosServicioTransporte['TipoServicioTransporte'] == "OPCIONAL SOLO SALIDA") {
            this.direccionExacta = "";
            this.telefonoCelularRepresentanteManiana = "";
            this.direccionRetorno = resp.DatosServicioTransporte['DireccionExacta']
          }
          this.telefonoCelularRepresentanteTarde = resp.DatosRepresentante['TelefonoCelularRepresentante'];
        }




        this.responsableContratacion = resp.DatosRepresentante['ResponsableContratacion'];
        if (this.responsableContratacion == "Mamá") {
          this.nombresResponsableMadre = resp.DatosRepresentante['NombreRepresentante'];
          this.emailResponsableMadre = resp.DatosRepresentante['EmailRepresentante'];
          this.telefonoResponsableMadre = resp.DatosRepresentante['TelefonoCelularRepresentante'];
          this.nombresResponsablePadre = "";
          this.emailResponsablePadre = "";
          this.telefonoResponsablePadre = "";
        }





        if (this.responsableContratacion == "Papá" || this.responsableContratacion == "Otro") {
          this.nombresResponsablePadre = resp.DatosRepresentante['NombreRepresentante'];
          this.emailResponsablePadre = resp.DatosRepresentante['EmailRepresentante'];
          this.telefonoResponsablePadre = resp.DatosRepresentante['TelefonoCelularRepresentante'];
          this.nombresResponsableMadre = "";
          this.emailResponsableMadre = "";
          this.telefonoResponsableMadre = "";
        }



        var date = new Date();
        this.anio = date.getFullYear()

        //var month = months[a.getMonth()];
        this.mes = date.getMonth() + 1;

        if (this.mes == 1) {
          this.mes = "enero";
        }
        if (this.mes == 2) {
          this.mes = "febrero";
        }

        if (this.mes == 3) {
          this.mes = "marzo";
        }

        if (this.mes == 4) {
          this.mes = "abril";
        }

        if (this.mes == 5) {
          this.mes = "mayo";
        }

        if (this.mes == 6) {
          this.mes = "junio";
        }

        if (this.mes == 7) {
          this.mes = "julio";
        }

        if (this.mes == 8) {
          this.mes = "agosto";
        }


        if (this.mes == 9) {
          this.mes = "septiembre";
        }

        if (this.mes == 10) {
          this.mes = "octubre";
        }


        if (this.mes == 11) {
          this.mes = "noviembre";
        }

        if (this.mes == 12) {
          this.mes = "diciembre";
        }

        this.dia = date.getDate();
        this.nombreContactoEmergencia = resp.DatosRepresentante['NombreOtroRepresentante'];
        this.emailContactoEmergencia = resp.DatosRepresentante['EmailOtroRepresentante'];
        this.telefonoContactoEmergencia = resp.DatosRepresentante['TelefonoCelularOtroRepresentante'];

        if (resp.DatosServicioTransporte['ValorAPagar'] != undefined) {
          var valor = resp.DatosServicioTransporte['ValorAPagar'].toFixed(2);
        }
        this.valorAPagar = valor;
        this.tipoServicio = resp.DatosServicioTransporte['TipoServicioTransporte'];

      }
      if (resp == undefined) {
        this.contadorPeticiones = this.contadorPeticiones + 1;
        if (this.contadorPeticiones <= 2) {
          ("undefined1")
          this.guardarDatos();
        }


      }

    })




  }



  contadorPeticiones: number = 0;


  invalidField(field: string) {
    return functions.invalidFields(field, this.ColegioFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldSteapDos(field: string) {
    return functions.invalidFields(field, this.DatosEstudianteFormGroup, this.formSubmittedUnidad);
  }



  invalidFieldStepTres(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepCuatro(field: string) {
    return functions.invalidFields(field, this.DatosFacturacionFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepCinco(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepSeis(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }


  getFiltroByNombreVacuna() {
    return null;
  }









  acciones() {
    if (this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value != " ") {
      //  console.log("true")
      //console.log("ENTRA AQUI 3")
      this.direccionRetornoP = false;
    } else {
      this.direccionRetornoP = true;
    }
  }






  validateNo(e): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }








  descargarPDFNew() {

    if (this.unidadEducativa === "VM" || this.unidadEducativa === "VME") {
      var texto = "";
    } else {
      var texto = "Pronto nos pondremos en contacto con usted.";
    }



    if (this.GetMuestraFinal === "CONTRATO") {
      this.descargaPdfUrl.download(this.cedulaEstudiante);

      Swal.fire({
        title: 'Su solicitud de transporte se ha registrado exitosamente',
        text: texto,
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',

        confirmButtonText: 'Aceptar'
      }).then((result) => {

        //window.location.href = "/gracias/CONTRATO";
        window.location.href = "/gracias";
      });


    }

    if (this.GetMuestraFinal === "VACIO" || this.GetMuestraFinal === "PDF") {
      Swal.fire({
        title: 'Su solicitud de transporte se ha registrado exitosamente',
        text: "Pronto nos pondremos en contacto con usted.",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',

        confirmButtonText: 'Aceptar'
      }).then((result) => {

        window.location.href = "/gracias";


      });
      return;
    }






  }


  pdfLink: boolean = false;
  pdfMake: boolean = false;
  createPdf() {
    //INICIOPDF


    if ((this.operadora+'').trim() === "FURGOPLANTA") {
      if (this.unidadEducativa === 'RS') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPANIA DE TRANSPORTES FURGOPLANTA ESTUDIANTIL E INSTITUCIONAL TRANSFURPLANT S.A.', style: 'header' },

            { text: 'COLEGIO RUDOLF STEINER CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Compañía de Transportes Furgoplanta Escolar', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El padre de Familia y la 0peradora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '  10 meses consecutivos ', bold: true }, "que tiene el año lectivo ( 2023 a JUNIO 2024), contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.- ', bold: true }, 'La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte de/a estudiante: en base las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n'], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES;', bold: true }, " pago que incluye los días: Sábados, domingos, feriados y los dias de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de trimestre. \n\n La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad,casos fortuitos o de fuerza mayor,no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-\n\n', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor por medio de la opción de RECAUDACIONES DEL BANCO DEL PICHINCHA a nombre de la COMPAÑIA DE TRANSPORTES FURGOPLANTA ESTUDIANTIL E INSTITUCIONAL TRANSFURPLANT S.A. y acercarse a la institución con el contrato firmado y el voucher.\n\n'
              ]
            },
            {
              text: [
                { text: 'CUARTA: NORMA.-', bold: true }, "El padre de familia declara haber recibido un lnstructivo del Transporte que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la 0peradora. \n\n"], alignment: 'justify',
            },
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los 28 dias del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '\n\n\n\n' },
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'LA OPERADORA\n', alignment: 'center', bold: true },
                  ]
                },

                {
                  text: [
                    { text: '\n\n\n\n' },
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'EL PADRE DE FAMILIA\n', alignment: 'center', bold: true },
                  ]
                }
              ]
            }
            ,

          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      
      if (this.unidadEducativa === 'MC') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPANIA DE TRANSPORTES FURGOPLANTA ESTUDIANTIL E INSTITUCIONAL TRANSFURPLANT S.A.', style: 'header' },

            { text: 'UNIDAD EDUCATIVA MARIE CLARAC', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Compañía de Transportes Furgoplanta Escolar', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El padre de Familia y la 0peradora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '  10 meses consecutivos ', bold: true }, "que tiene el año lectivo ( 2023 a JUNIO 2024), contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.- ', bold: true }, 'La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte de/a estudiante: en base las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n'], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES;', bold: true }, " pago que incluye los días: Sábados, domingos, feriados y los dias de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de trimestre. \n\n La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad,casos fortuitos o de fuerza mayor,no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-\n\n', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor por medio de la opción de RECAUDACIONES DEL BANCO DEL PICHINCHA a nombre de la COMPAÑIA DE TRANSPORTES FURGOPLANTA ESTUDIANTIL E INSTITUCIONAL TRANSFURPLANT S.A. y acercarse a la institución con el contrato firmado y el voucher.\n\n'
              ]
            },
            {
              text: [
                { text: 'CUARTA: NORMA.-', bold: true }, "El padre de familia declara haber recibido un lnstructivo del Transporte que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la 0peradora. \n\n"], alignment: 'justify',
            },
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " dias del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '\n\n\n\n' },
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'LA OPERADORA\n', alignment: 'center', bold: true },
                  ]
                },

                {
                  text: [
                    { text: '\n\n\n\n' },
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'EL PADRE DE FAMILIA\n', alignment: 'center', bold: true },
                  ]
                }
              ]
            }
            ,

          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }


    }



    if (this.operadora === "UNIPRO") {
      //unipro particulaes
      if (this.unidadEducativa === 'I') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },

            { text: 'Colegio Instisana', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un año prorrateado a", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, 'La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, con un servicio puerta a puerta, siempre y cuando las condiciones de accesibilidad y Leyes de Tránsito lo permitan, en base a las rutas establecidas y según el contrato suscrito con la Operadora, con las mejores condiciones de bioseguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, y, el horario establecido por el Plantel Educativo, de lunes a viernes. El Servicio de Transporte, cuenta con una asistente para el control de protocolos de bioseguridad de los estudiantes, teléfono celular y control permanente del servicio.\n\n'], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES.', bold: true }, { text: ' El valor de $77,00 (setenta y siete dólares)', bold: true }, " dentro del perímetro de la ciudad y, ", { text: ' $90,00 (noventa dólares)', bold: true }, " para los Valle dependiendo de la cobertura. La Operadora se reserva el derecho de suspender el servicio de transporte a los estudiantes que no hayan cancelado oportunamente el servicio."], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con un adulto responsable 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar oportunamente al Colegio.  Los conductores no pitaran ni esperaran a los estudiantes por respeto a sus compañeros.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admiten cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación de Transporte del Colegio con un mínimo de 8 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran, (cada unidad deberá completar mínimo el 80% de su capacidad).\n\n',

              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '\n\n\n\n' },
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },

                {
                  image: 'data:image/png;base64,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',
                  width: 200
                }
              ]
            },
            {
              text: [
                "\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo ", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.', bold: true }, "\n\n\n"], alignment: 'justify',
            },
            {
              text: [
                { text: 'UNIPRO C.A', bold: true, style: 'header' }],
            },
            {
              text: [
                { text: '"INSTRUCTIVO DE SEGURIDAD DEL TRANSPORTE ESCOLAR  2022-2023 DE LOS ESTUDIANTES"', bold: true, style: 'subheader' }],
            },
            {
              text: [
                "\n\n"], alignment: 'justify',
            },
            {
              alignment: 'justify',
              ol: [

                'Sujetarse a la normativa disciplinaria vigente en la Unidad Educativa y mantener una relación de respeto para con los conductores y asistentes.',
                'Seguir las instrucciones dadas por el conductor, esperar en la mañana el transporte con un adulto responsable en la acera o parada designada, 5 minutos antes del horario establecido por el conductor, lo cual ayudará a que la unidad de transporte pueda cumplir con su itinerario normal de recorrido y llegar oportunamente al Colegio. Los conductores no pitaran ni esperaran a los estudiantes por respeto a sus compañeros.',
                'Utilizar el cinturón de seguridad de forma permanente y permanecer sentados durante todo el recorrido de ingreso o salida del Colegio. Esperar que el vehículo se detenga completamente para subir o bajar con seguridad.',
                'Utilizar la mascarilla permanentemente durante todo el recorrido, mientras dure la pandemia o hasta cuando las Autoridades del Colegio lo dispongan.',
                'Mantener permanentemente un comportamiento correcto, evitar gritar o utilizar un lenguaje inapropiado y no agredir físicamente a sus compañeros durante el recorrido. No sacar las manos o la cabeza por las ventanillas.',
                'Cuidar el interior del vehículo, el mismo que está a su servicio, manteniéndolo limpio y en buen estado, se prohíbe consumir alimentos o bebidas en la unidad de transporte. No arrojar basura a la calle por las ventanas, pues esto constituye una infracción de tránsito que debe asumir injustamente el conductor. ',
                'Los estudiantes serán responsables de cualquier daño que causen al interior o exterior del vehículo y el Padre de Familia deberá reconocer el perjuicio realizado.',
                'Por seguridad de los estudiantes, por ningún concepto pueden quedarse en otros lugares que no sean sus paradas o direcciones autorizadas por los Padres de Familia. ',
                'Permanecer en calma en su asiento durante cualquier emergencia que se presente, hasta recibir instrucciones de la Asistente.',
                'Cuidar los objetos personales y no olvidarlos en la unidad de transporte, ya que su pérdida no es responsabilidad del conductor.',
                'Por seguridad de los estudiantes, queda terminantemente prohibido tomar cualquier otra unidad de transporte que no le corresponde, sin el conocimiento y autorización de la Coordinación del Transporte en el Colegio.',
                'El incumplimiento de estas normativas será informado a las Autoridades del Colegio y en caso de reincidencia se suspenderá el servicio de manera temporal o definitiva de acuerdo al Reglamento de Transporte.\n\n',

              ]
            }

            ,
            {
              text: [
                { text: 'UNIPRO C.A:', bold: true, style: 'header' }],
            },
            {
              text: [
                { text: '"INSTRUCTIVO DE SEGURIDAD DEL TRANSPORTE ESCOLAR  2022-2023 DE LOS SEÑORES PADRES DE FAMILIA:"', bold: true, style: 'subheader' }],
            },

            ,
            {
              text: ["\n\n"], alignment: 'justify',
            },
            {
              alignment: 'justify',
              ol: [
                'Como es de su conocimiento, nuestro país viene soportando un incremento desmedido de la delincuencia y la consiguiente inseguridad para la ciudadanía, esto ha ocasionado que debamos tomar medidas de prevención, por lo que solicitamos a los Padres de Familia, Estudiantes y Asistentes del transporte, un compromiso conjunto a fin de prevenir cualquier incidente de esta naturaleza. ',
                'La Operadora ha implementado una plataforma digital que permitirá a los Padres de Familia y la Coordinación de transporte en el Colegio, supervisar en tiempo real a la unidad de transporte escolar asignada a cada estudiante.',
                'Por seguridad de los estudiantes, es necesario que tanto los Padres de Familia, estudiantes y transportistas, cumplan puntualmente los horarios establecidos por los conductores de las unidades de transporte, tanto al recogerles en la mañana como al dejarles en la tarde. ',
                'Prestación del servicio: El servicio de transporte escolar es opcional y no obligatorio, será decisión libre y voluntaria del Padre de Familia contratarlo, tomando en cuenta su compromiso de pago por el período de 10 meses consecutivos.',
                'El pago por el servicio de transporte es mensualizado, la Operadora no dispone el servicio por días, ni por semanas; pues mantiene un compromiso de pago con los señores transportistas y asistentes de manera también mensualizada.',
                'Revisar e instruir a sus hijos, sobre el contenido y cumplimiento del presente Instructivo de Seguridad del transporte, a fin de que el servicio se lo realice con normalidad y seguridad.',
                'Tomar las debidas precauciones mientras los estudiantes esperan el bus en la mañana y registrar en la Coordinación del Transporte al inicio del año escolar, el nombre y número telefónico de la persona autorizada de recibir al estudiante al retorno a su domicilio.  Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'Conocer que los vehículos no podrán ingresar a conjuntos residenciales pequeños, ni a pasajes o calles sin salida y caminos en mal estado.',
                'Indicar a sus hijos, que, por actos de indisciplina en el transporte serán reportados al DECE del Colegio, este servicio puede ser suspendido temporal o definitivamente.',
                'Cuando los Padres de Familia requieran un cambio de recorrido temporal o definitivo para sus hijos, deberán solicitar al menos con ocho días de anticipación a la Coordinación del Transporte en el Colegio, dicha solicitud será atendida siempre y cuando existan cupos en las unidades de servicio y se encuentren al día en los pagos.',
                'Por seguridad de los estudiantes, es necesario mantener siempre actualizados los números telefónicos y correos electrónicos de los Padres de Familia con la Coordinación del Transporte en el Colegio.',
                'Informar al Colegio y a la Coordinación de Transporte, cuando por alguna circunstancia algún padre de familia necesite retirar a su hijo a la salida del Colegio, a fin de notificar a la Asistente y Conductor esta novedad.',

              ]
            },

            {
              text: ["\n\n\n\n"], alignment: 'justify',
            },
            {
              columns: [{},

              {

                image: 'data:image/png;base64,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',
                width: 200

              }, {}
              ]
            }

            ,

          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      //unipro fiscales
      if (this.unidadEducativa === 'FS') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'Unidad Educativa Domingo Faustino Sarmiento', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, que consiste en trasladarse desde las vías principales aledañas a sus domicilios hacia la Institución Educativa y viceversa, con paradas específicas, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora. La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [

                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n',
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.:', bold: true }, "\n\n\n"], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === 'AL') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },

            { text: ' Escuela de Educación Básica Abraham Lincoln', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, que consiste en trasladarse desde las vías principales aledañas a sus domicilios hacia la Institución Educativa y viceversa, con paradas específicas, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora. La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [

                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n',
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.:', bold: true }, "\n\n\n"], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      //unipro bicentenarios
      if (this.unidadEducativa === 'MB') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'Unidad Educativa Municipal del Milenio Bicentenario', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, " La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante,",
                " por las vías colectoras o ejes viales principales aledaños a sus domicilios, hacia la Unidad Educativa y viceversa, siempre y cuando las condiciones de",
                " accesibilidad y las normas de Tránsito lo permitan, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones",
                " de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo,",
                " de lunes a viernes. \nEl Servicio de Transporte, cuenta con servicio de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio."], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora. La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n'
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo ", { text: this.emailAdmin }, { text: ' La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.\n\n\n', bold: true },], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }

      if (this.unidadEducativa === 'PA') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'Unidad Educativa Planeta Azul', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante de la Unidad Educativa Particular "Charles Darwin"',] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, que consiste en trasladarse desde sus domicilios hacia el Plantel Educativo y viceversa, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes. \nEl Servicio de Transporte, cuenta con una asistente para el control de protocolos de bioseguridad de los estudiantes, servicio permanente de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio."], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora.\n La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.', 'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n'
                , 'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.']
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo ", { text: this.emailAdmin }, " ", { text: 'La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.', bold: true }], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === 'SK') {
        return;
      }
      if (this.unidadEducativa === 'CI') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'Unidad Educativa María Angélica Idrobo', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, con un servicio puerta a puerta para los estudiantes de nivel Inicial y Primaria, siempre y cuando las condiciones de accesibilidad y las normas de Tránsito lo permitan. Para los estudiantes de Secundaria el servicio consiste en trasladarse desde las vías principales aledañas a sus domicilios hacia la Institución Educativa y viceversa, con paradas específicas, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes.\nEl Servicio de Transporte, cuenta con una asistente para el control de protocolos de bioseguridad de los estudiantes de Inicial y Primaria, servicio permanente de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora. La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [

                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.',
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.:', bold: true }, "\n\n\n"], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === 'CD' || this.unidadEducativa === 'ECD') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'Unidad educativa particular "Charles Darwin"', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, con un servicio puerta a puerta, siempre y cuando las condiciones de accesibilidad y las normas de Tránsito lo permitan, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes. \nEl Servicio de Transporte, cuenta con una asistente para el control de protocolos de bioseguridad de los estudiantes, servicio permanente de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora.\n La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n',
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.:', bold: true }, "\n\n\n"], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === 'CB') {
        var pdfDefinition: any = {
          content: [
            { text: 'COMPAÑÍA DE TRANSPORTE ESCOLAR "UNIPRO"', style: 'header' },
            { text: 'COLEGIO BRITÁNICO', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE AÑO ESCOLAR  2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la", { text: 'Compañía de transporte Escolar "UNIPRO C.A., "', bold: true }, ' a quien para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando al estudiante: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true },] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, con un servicio puerta a puerta, siempre y cuando las condiciones de accesibilidad y las normas de Tránsito lo permitan, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes. \nEl Servicio de Transporte, cuenta con una asistente para el control de protocolos de bioseguridad de los estudiantes, servicio permanente de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES, en efectivo, cheques o transferencias bancarias.', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                "El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora.\n La operadora",
                { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n', bold: true }], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n',
              ]
            },
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre Representante legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'Cédula/Pasaporte: ' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Representante operadora UNIPRO\n', alignment: 'center', bold: true },
                    { text: 'Ruc: 1790935426001', alignment: 'center', bold: true }
                  ]
                }
              ]
            },
            {
              text: ["\n\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'NOTA:', bold: true }, "Una vez aceptado los términos y condiciones de este contrato, favor remitir al correo", { text: this.emailAdmin }, { text: ', La Operadora al recibir la confirmación del presente contrato, dará por aceptado el mismo.:', bold: true }, "\n\n\n"], alignment: 'justify',
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }


    }

    if (this.operadora === "TRANSJODEFU") {

    }

    if (this.operadora === "CIUDAD_QUITO") {
      //colegio mercedes novoa
      if (this.unidadEducativa === "MN" || this.unidadEducativa === "MNV") {
        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR, TURISMO Y AFINES "CIUDAD DE QUITO"', style: 'header' },
            { text: 'Escuela de educación básica Mercedes Noboa', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte escolar, turismo y afines "CIUDAD DE QUITO, "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte del/a estudiante: en base a las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES; ', bold: true }, ' pago que incluye los días: Sábados, domingos, feriados y los días de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de quimestre.\n\n'], alignment: 'justify',
            }
            ,
            {
              text: [
                "La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad, casos fortuitos o de fuerza mayor, no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor a la cuenta corriente del Banco del Pichincha Nº 2100072737, RUC: 1791023544001 a nombre COOPERATIVA DE TRANSPORTE ESCOLAR "CIUDAD DE QUITO" y acercarse a la  institución con el contrato firmado y el voucher.\n\n'
              ]
            }
            ,
            {
              text: [
                { text: 'CUARTA NORMA.-', bold: true }, "El Padre de Familia declara haber recibido un Instructivo del Transporte, que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la Operadora.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [

                    { text: 'LA OPERADORA ', alignment: 'center', bold: true },

                  ]
                },
                {
                  text: [

                    { text: 'EL PADRE DE FAMILIA', alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }

      if (this.unidadEducativa === "LRV" || this.unidadEducativa === "LRM") {
        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR, TURISMO Y AFINES "CIUDAD DE QUITO"', style: 'header' },
            { text: 'Jardín de infantes Jose Luis Roman', style: 'subheader' },

            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte escolar, turismo y afines "CIUDAD DE QUITO, "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte del/a estudiante: en base a las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES; ', bold: true }, ' pago que incluye los días: Sábados, domingos, feriados y los días de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de quimestre.\n\n'], alignment: 'justify',
            }
            ,
            {
              text: [
                "La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad, casos fortuitos o de fuerza mayor, no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor a la cuenta corriente del Banco del Pichincha nº2100072737, RUC: 1791023544001 a nombre COOPERATIVA DE TRANSPORTE ESCOLAR “CIUDAD DE QUITO” y acercarse a la  institución con el contrato firmado y el voucher.\n\n'
              ]
            }
            ,
            {
              text: [
                { text: 'CUARTA NORMA.-', bold: true }, "El Padre de Familia declara haber recibido un Instructivo del Transporte, que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la Operadora.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [

                    { text: 'LA OPERADORA ', alignment: 'center', bold: true },

                  ]
                },
                {
                  text: [

                    { text: 'EL PADRE DE FAMILIA', alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }

      if (this.unidadEducativa === "COT") {
        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR, TURISMO Y AFINES "CIUDAD DE QUITO"', style: 'header' },
            { text: 'UNIDAD EDUCATIVA DE AVIACIÓN CIVIL', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte escolar, turismo y afines "CIUDAD DE QUITO, "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte del/a estudiante: en base a las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES; ', bold: true }, ' pago que incluye los días: Sábados, domingos, feriados y los días de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de quimestre.\n\n'], alignment: 'justify',
            }
            ,
            {
              text: [
                "La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad, casos fortuitos o de fuerza mayor, no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor a la cuenta corriente del Banco del Pacifico Nº 08034966, RUC: 1791023544001 a nombre COOPERATIVA DE TRANSPORTE ESCOLAR "CIUDAD DE QUITO" y acercarse a la  institución con el contrato firmado y el voucher.',
              ]
            }
            ,
            {
              text: [
                { text: 'CUARTA NORMA.-', bold: true }, "El Padre de Familia declara haber recibido un Instructivo del Transporte, que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la Operadora.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [

                    { text: 'LA OPERADORA ', alignment: 'center', bold: true },

                  ]
                },
                {
                  text: [

                    { text: 'EL PADRE DE FAMILIA', alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === "LT") {
        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR, TURISMO Y AFINES "CIUDAD DE QUITO"', style: 'header' },
            { text: 'Jardín de infantes Lucinda Toledo', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte escolar, turismo y afines "CIUDAD DE QUITO, "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte del/a estudiante: en base a las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES; ', bold: true }, ' pago que incluye los días: Sábados, domingos, feriados y los días de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de quimestre.\n\n'], alignment: 'justify',
            }
            ,
            {
              text: [
                "La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad, casos fortuitos o de fuerza mayor, no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [

                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor a la cuenta ahorros del Banco del Pichincha Nº 3210270700, RUC: 1791023544001 a nombre COOPERATIVA DE TRANSPORTE ESCOLAR “CIUDAD DE QUITO” y acercarse a la  institución con el contrato firmado y el voucher.\n\n'
              ]
            }
            ,
            {
              text: [
                { text: 'CUARTA NORMA.-', bold: true }, "El Padre de Familia declara haber recibido un Instructivo del Transporte, que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la Operadora.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [

                    { text: 'LA OPERADORA ', alignment: 'center', bold: true },

                  ]
                },
                {
                  text: [

                    { text: 'EL PADRE DE FAMILIA', alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === "LV" || this.unidadEducativa === "LVM") {
        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR, TURISMO Y AFINES "CIUDAD DE QUITO"', style: 'header' },
            { text: 'Escuela Juan Francisco Leoro Vasquez', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte escolar, turismo y afines "CIUDAD DE QUITO, "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La operadora se obliga para con el padre de Familia, a prestar el Servicio de Transporte del/a estudiante: en base a las rutas establecidas y según el contrato suscrito con el colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT) y la Ley de Tránsito, según el horario establecido por el Plantel Educativo de lunes a viernes.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES; ', bold: true }, ' pago que incluye los días: Sábados, domingos, feriados y los días de descanso obligatorio establecidos por el Ministerio de Educación para el cambio de quimestre.\n\n'], alignment: 'justify',
            }
            ,
            {
              text: [
                "La Operadora se reserva el derecho de suspender el transporte a los estudiantes que no hayan cancelado oportunamente este servicio. La ausencia temporal o total del estudiante dentro de cualquier mes, ya sea por enfermedad, casos fortuitos o de fuerza mayor, no otorga derecho alguno a que se le realicen descuentos, devoluciones o abonos a meses posteriores.\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque que los estudiantes cumplan con los horarios y paradas establecidas, esperando con 5 minutos de anticipación la llegada del bus, los señores conductores tienen un itinerario para llegar oportunamente al colegio y disposiciones expresas de no pitar ni esperar.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes, especialmente a los más pequeños. Se deja constancia que la responsabilidad del conductor empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.',
                'El padre de familia una vez inscrito deberá cancelar el valor a la cuenta corriente del Banco del Pichincha Nº 2100072736, RUC: 1791023544001 a nombre COOPERATIVA DE TRANSPORTE ESCOLAR “CIUDAD DE QUITO” y acercarse a la  institución con el contrato firmado y el voucher.\n\n'

              ]
            }
            ,
            {
              text: [
                { text: 'CUARTA NORMA.-', bold: true }, "El Padre de Familia declara haber recibido un Instructivo del Transporte, que forma parte integral del presente Contrato, con obligaciones para los Estudiantes, Padres de Familia y la Operadora.\n", "*Importante: Se incrementará un valor adicional al total del valor del servicio el cual es $1.00 el cual consiste en la implementación de la plataforma de monitoreo, botón de pánico,rastreo satélite con la finalidad de brindar mayor seguridad al estudiante y facilidad al padre de familia bajo el maneja de una aplicación a la cual el representante principal tendrá acceso.\n\n"], alignment: 'justify',

            }
            ,
            {
              text: [
                { text: 'QUINTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [

                    { text: 'LA OPERADORA', alignment: 'center', bold: true },

                  ]
                },
                {
                  text: [

                    { text: 'EL PADRE DE FAMILIA', alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }

    }

    if (this.operadora === "UNION") {

      if (this.unidadEducativa === "VM" || this.unidadEducativa === "VME") {
        var pdfDefinition: any = {
          content: [
            { text: ' COOPERATIVA DE TRANSPORTE ESCOLAR "UNIÓN"', style: 'header' },
            { text: 'Unidad Educativa Fiscal 24 de Mayo', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, ", { text: 'la Cooperativa de transporte escolar "UNIÓN" "', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El padre de familia se compromete a cancelar el valor antes descrito de manera mensual. ", { text: 'Dentro de los primeros (10) días de cada mes,', bold: true }, " por el lapso de 10 meses, comprendidos de: (septiembre a junio regimen sierra). A la suscripción del siguiente contrato recibiré los siguientes beneficios: \n\n"], alignment: 'justify', },


            {

              alignment: 'justify',
              ol: [
                'Que mi representado viaje en forma segura en una unidad escolar que tenga los permisos legales respectivos autorizados por la ANT o los GAD según corresponda.',
                'Que la unidad de transporte retire y deje a mi representado en la parada asignada de forma puntual en el horario asignado.',
                'Recibir un trato cordial y respetuoso por parte del señor conductor de la unidad de transporte y del personal administrativo de la empresa de transporte.',
                'Que la unidad en la que se transportará mi representado, cumpla con las disposiciones señaladas en la Ley Orgánica de Transporte Terrestre, Tránsito y Seguridad Vial, reglamento de Transporte Escolar e Institucional y al Acuerdo Ministerial MINEDUC - MINEDUC - 2018-007-A de 13 De agosto de 2018 y su instructivo de aplicación.\n\n',
              ]
            }

            ,
            { text: ["Las disposiciones a las que me comprometo cumplir son las siguientes: \n\n"], alignment: 'justify', },

            {

              alignment: 'justify',
              ol: [
                'Velar porque mi hijo o representado cumpla estrictamente con el horario establecido por la autoridad educativa para el recorrido del transporte escolar, es decir debe estar, cinco (5) minutos antes de la hora establecida.',
                'Velar porque mi hijo o representado mantenga un comportamiento adecuado en la unidad de transporte, de lo contrario acepto que de ser el caso, sea suspendido del mismo sin derecho a una retribución económica.',
                'Informar oportunamente vía telefónica al transportista y/o al coordinador de transportes, cuando mi hijo o representado no vaya hacer uso del transporte escolar por situaciones de enfermedad o cualquier otro imprevisto ocasional respecto al normal y habitual uso del servicio.',
                'Si por necesidad el estudiante requiere cambiar de ruta en horas de la tarde o bajarse en un sitio distinto al acostumbrado, me comprometo a presentar la respectiva autorización de la autoridad institucional.',
                'En el caso de que mi hijo o representado ocasione daños materiales a la unidad de transporte me comprometo a cancelar los valores generados.',
                'Entiendo que el valor a cancelar corresponde al mes del servicio contratado y si mi hijo o representado no hace uso del mismo sin que yo notifique de este particular a quien corresponda para la suspensión o cancelación del presente documento, no estoy exento de los valores generados.',
                '"Aplica solo a Escuela" Me comprometo a que siempre exista una persona autorizada quien reciba en la parada establecida a mi representado; caso contrario el transportista podrá retornar al estudiante a la institución educativa donde el representante deberá acercarse a retirarlo.\n\n',
              ]
            },
            {
              text: [
                "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            }
            ,
            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'LA OPERADORA \n', alignment: 'center', bold: true },
                    { text: 'COOPERATIVA DE TRANSPORTE UNION \n', alignment: 'center', bold: true },
                    { text: 'RUC: 1790165507001 ', alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'Nombre del Represente legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'CI/PASAPORTE:' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                }
              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === "UP") {

        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR "UNIÓN"', style: 'header' },
            { text: 'Unidad Educativa Primavera', style: 'subheader' },
            { text: 'CONTRATO DE PRESTACIÓN SERVICIO DE TRANSPORTE', style: 'subheader' },
            { text: 'AÑO ESCOLAR 2022-2023', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte Escolar "UNIÓN", ', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El Padre de Familia y la Operadora, libre y voluntariamente convienen en celebrar el presente Contrato de Prestación de Servicio de Transporte Escolar, por un período de", { text: '10', bold: true }, " meses consecutivos que tiene el año lectivo", { text: '(SEPTIEMBRE 2022 a JUNIO 2023)', bold: true }, ", contenido en las siguientes cláusulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.-', bold: true }, "La Operadora se compromete para con el padre de Familia, a prestar el Servicio de Transporte del/la estudiante, con un servicio puerta a puerta, siempre y cuando las condiciones de accesibilidad y las normas de Tránsito lo permitan, en base a las rutas establecidas y según el contrato suscrito con él Colegio, con las mejores condiciones de seguridad y cumpliendo las normas emitidas por la Agencia Metropolitana de Tránsito (AMT), Ley de Tránsito y, el horario establecido por el Plantel Educativo, de lunes a viernes.El Servicio de Transporte, cuenta con servicio permanente de comunicación mediante una plataforma digital, teléfono celular y control permanente del servicio.\n\n"], alignment: 'justify',
            },



            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.-', bold: true }, "El Padre de Familia se compromete a cancelar mensualmente por este servicio, dentro de los ", { text: 'DIEZ PRIMEROS DÍAS DE CADA MES.\n ', bold: true }, 'El Padre de familia si escoge realizar el pago mediante transferencias bancarias, se compromete remitir copia del documento a la Coordinación del transporte, dando a conocer el nombre del estudiante, a fin de validar el pago en el sistema contable de la Operadora.\n La operadora', { text: '"se reserva el derecho de suspender el servicio de transporte, a los estudiantes que no hayan cancelado el valor correspondiente en el plazo estipulado."\n\n ', bold: true }], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'TERCERA: OBLIGACIONES DEL PADRE DE FAMILIA.-', bold: true }], alignment: 'justify',

            }, {
              type: 'lower-alpha',
              alignment: 'justify',
              ol: [
                'Velar porque los estudiantes cumplan con los horarios y paradas establecidas por el Colegio, esperando el transporte con 5 minutos de anticipación, pues los conductores tienen un itinerario para llegar con seguridad y oportunamente al Colegio.',
                'Tomar las debidas precauciones de seguridad al enviarles y recibirles a los estudiantes. No se admite cambios de estudiantes en las unidades de transporte, salvo casos de fuerza mayor o por cambio de domicilio, previa solicitud escrita a la Coordinación del transporte con un mínimo de 10 días de anticipación, siempre y cuando exista disponibilidad de cupo en las unidades de transporte o exista servicio de transporte para el sector del domicilio solicitado.',
                'El servicio de transporte es organizado y sectorizado por la Compañía y supervisado por el Colegio, la factibilidad de brindar el servicio o incrementar una unidad de transporte, dependerá de la ubicación del domicilio y el número de estudiantes que lo requieran.\n\n']
            }

            ,
            {
              text: [
                { text: 'CUARTA.-', bold: true }, "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },

            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre del Represente legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'CI/PASAPORTE:' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: ' Representante operadora UNIÓN\n', alignment: 'center', bold: true },
                    { text: 'RUC: 1790165507001 ', alignment: 'center', bold: true }
                  ]
                }

              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === "FAE" || this.unidadEducativa === "FAEV") {

        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR "UNIÓN"', style: 'header' },
            { text: 'Unidad Educativa FAE', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte Escolar "UNIÓN", ', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El padre de familia se compromete a cancelar el valor antes descrito de manera mensual. ", { text: 'Dentro de los primeros (10) días de cada mes, ', bold: true }, "por el lapso de 10 meses, comprendidos de: (septiembre a junio régimen sierra). A la suscripción del siguiente contrato recibiré los siguientes beneficios: \n\n"], alignment: 'justify', },


            {

              alignment: 'justify',
              ol: [
                'Que mi representado viaje en forma segura en una unidad escolar que tenga los permisos legales respectivos autorizados por la ANT o los GAD según corresponda.',
                ' Que la unidad de transporte retire y deje a mi representado en la parada asignada de forma puntual en el horario asignado.',
                'Recibir un trato cordial y respetuoso por parte del señor conductor de la unidad de transporte y del personal administrativo de la empresa de transporte.',
                'Que la unidad en la que se transportará mi representado, cumpla con las disposiciones señaladas en la Ley Orgánica de Transporte Terrestre, Tránsito y Seguridad Vial, reglamento de Transporte Escolar e Institucional y al Acuerdo Ministerial MINEDUC - MINEDUC - 2018-007-A de 13 De agosto de 2018 y su instructivo de aplicación.\n\n',

              ]
            }

            ,
            { text: ["Las disposiciones a las que me comprometo cumplir son las siguientes:\n"], alignment: 'justify', },

            {

              alignment: 'justify',
              ol: [
                'Velar porque mi hijo o representado cumpla estrictamente con el horario establecido por la autoridad educativa para el recorrido del transporte escolar, es decir debe estar, cinco (5) minutos antes de la hora establecida.',
                'Velar porque mi hijo o representado mantenga un comportamiento adecuado en la unidad de transporte, de lo contrario acepto que de ser el caso, sea suspendido del mismo sin derecho a una retribución económica.',
                'Informar oportunamente vía telefónica al conductor, acompañante de los estudiantes o al directivo de la institución educativa, cuando mi hijo o representado no vaya hacer uso del transporte escolar por situaciones de enfermedad o cualquier u otro imprevisto ocacional respecto al normal y habitual uso del servicio.',
                'Si por necesidad el estudiante debiere cambiar de ruta en horas de la tarde o bajarse en un sitio distinto al acostumbrado, me comprometo a presentar la respectiva autorización de la autoridad institucional.',
                'En el caso de que mi hijo o representado ocasione daños materiales a la unidad de transporte me comprometo a cancelar los valores generados.',
                'Entiendo que el valor a cancelar corresponde al mes del servicio contratado y si mi hijo o representado no hace uso del mismo sin que yo notifique de este particular a quien corresponda para la suspención o cancelacion del presente documento, no estoy exento de los valores generados.\n',
              ]
            }
            ,
            { text: ['"Nos reservamos el derecho de suspender el servicio de transporte por inclumplimiento a las fechas de pago establecidas sin opción a reclamo o retribución económica."\n\n'], alignment: 'justify', },

            ,
            {
              text: [
                "Para constancia de lo estipulado y dando fe de aceptación las partes suscriben el presente Contrato en el Distrito Metropolitano de Quito a los ", { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },
            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre del Represente legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'CI/PASAPORTE:' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: ' Representante operadora UNIÓN\n', alignment: 'center', bold: true },
                    { text: 'RUC: 1790165507001 ', alignment: 'center', bold: true }
                  ]
                }

              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }
      if (this.unidadEducativa === "HC") {

        var pdfDefinition: any = {
          content: [
            { text: 'COOPERATIVA DE TRANSPORTE ESCOLAR "UNIÓN"', style: 'header' },
            { text: 'Unidad Educativa Hipatia Cárdenas de Bustamante', style: 'subheader' },
            { text: 'CONTRATO POR SERVICIO DE TRANSPORTE ESCOLAR', style: 'subheader' },

            { alignment: 'justify', text: ["En la ciudad de Quito comparecen, por una parte, la ", { text: 'Cooperativa de transporte Escolar "UNIÓN", ', bold: true }, ' a quién y para efectos del presente contrato se le denominará "LA OPERADORA", por otra parte, el Señor (a) ', { text: this.nombreRepresentante + " C.C." + this.cedulaRepresentante, bold: true }, ', a quien en adelante se le denominará "EL PADRE DE FAMILIA", representando a: ', { text: this.apellidosEstudiante + " " + this.nombresEstudiante + ".", bold: true }] },

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Apellidos y nombres del estudiante', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Grado/Curso', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Sección-Cédula/Pasaporte', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.apellidosEstudiante + " " + this.nombresEstudiante, fontSize: 10 }, { text: this.gradoyParalelo, fontSize: 10 }, { text: this.cedulaEstudiante, fontSize: 10 }]
                ]
              }
            },


            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / mañana', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionExacta, fontSize: 10 }, { text: this.telefonoCelularRepresentanteManiana, fontSize: 10 }]
                ]
              }
            },

            {
              style: 'tableExample',
              table: {
                widths: [340, 150],
                body: [
                  [{ text: 'Dirección domicilio / tarde', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.direccionRetorno, fontSize: 10 }, { text: this.telefonoCelularRepresentanteTarde, fontSize: 10 }]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre padre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsablePadre, fontSize: 10 }, { text: this.emailResponsablePadre, fontSize: 10 }, { text: this.telefonoResponsablePadre, fontSize: 10 }]
                ]
              }
            }
            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre madre', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombresResponsableMadre, fontSize: 10 }, { text: this.emailResponsableMadre, fontSize: 10 }, { text: this.telefonoResponsableMadre, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [230, 125, 125],
                body: [
                  [{ text: 'Nombre contacto EMERGENCIA', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'E-mail', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Telf.', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.nombreContactoEmergencia, fontSize: 10 }, { text: this.emailContactoEmergencia, fontSize: 10 }, { text: this.telefonoContactoEmergencia, fontSize: 10 }]
                ]
              }
            }

            ,
            {
              style: 'tableExample',
              table: {
                widths: [245, 245],
                body: [
                  [{ text: 'VALOR MENSUAL DEL TRANSPORTE', style: 'tableCabecera', fontSize: 10, alignment: 'center' }, { text: 'Tipo de servicio', style: 'tableCabecera', fontSize: 10, alignment: 'center' }],
                  [{ text: this.valorAPagar, fontSize: 10 }, { text: this.tipoServicio, fontSize: 10 }]
                ]
              }
            },
            { text: ["El padre de familia y el contratista, convienen celebrar el presente convenio de prestación de servicio de transporte, contenido en las siguientes clausulas: \n\n"], alignment: 'justify', },


            {
              text: [
                { text: 'PRIMERA: OBJETO.- ', alignment: 'justify', bold: true }, 'El Contratista se obliga para con el padre de familia a prestar del servicio de Transporte del/ a estudiante, que consiste en trasladarse desde un lugar cercano a su domicilio hasta el Plan Educativo y viceversa. Este servicio se realizará por vías principales con unidades legalmente autorizadas por la AMT, según el horario establecido por el Plantel Educativo para elingreso y salida de clases, de lunes a viernes.', ".\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'SEGUNDA: PRECIO Y FORMA DE PAGO.- ', alignment: 'justify', bold: true }, ' El padre de familia cancelara mensualmente por este servicio, el valor de: acuerdo al sector;', ".\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'RECORRIDO LARGO: $35,00', alignment: 'justify', bold: true }, '', ".\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'RECORRIDO CORTO:$28,00', alignment: 'justify', bold: true }, '', ".\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                'Durante los primeros cinco días de cada mes, mediante el sistema cash y utilizando el código asignado a cada estudiante por el servicio de transporte, de la Cooperativa de Transporte Unión.', ".\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'TERCERA PLAZO.- ', alignment: 'justify', bold: true }, 'El plazo de duración de este convenio es de DIEZ MESES, el mismo que rige de a partir de SEPTIEMBRE 2022 hasta junio 2023.', ".\n\n"], alignment: 'justify',
            }
            ,


            ,
            {
              text: [
                { text: 'CUARTA. OBLIGACIONES DEL PADRE DE FAMILIA.- ', alignment: 'justify', bold: true }, 'A través del presente convenio el padre de familia se compromete cancelar valor estipulado en la cláusula segunda, caso contrario acepta que el contratista se reserve el derecho de suspender el servicio.', ".\n\n"], alignment: 'justify',
            }
            ,


            ,
            {
              text: [
                { text: 'QUINTA: OBLIGACIONES DEL CONTRATISTA:', alignment: 'justify', bold: true }, '', ".\n"], alignment: 'justify',
            }
            ,

            {
              type: 'upper-alpha',
              ol: [
                'El contratista se obliga a otorgar la factura correspondiente a los señores padres de familia que hayan cancelado estos valores.',
                'En caso que la unidad de transporte con la que se realizara el recorrido diario, se dañe o sufriera algún desperfecto, el contratista se compromete a remplazarla de manera inmediata con otra unidad.',
                'El contratista se compromete a cumplir con la ruta establecida y con el horario de ingreso y salida que establece el plantel.',
                'En caso de incremento en pasajes y/o combustibles se regulara el valor de transporte de acuerdo a las disposiciones gubernamentales.\n\n',
              ]
            },
            {
              text: [
                { text: 'SEXTA.- ', alignment: 'justify', bold: true }, 'El contratista establecerá si existe el número suficiente de estudiantes que amerite la contratación de unidades de transporte para determinadas rutas de no ser así no se compromete a proveer el servicio para estos sectores, lo cual será motivo de anulación del presente convenio de transporte.', ".\n\n"], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'SEPTIMA.- ', alignment: 'justify', bold: true }, 'Los / as estudiantes deberán esperar a la unidad de transporte con la debida anticipación, 5 minutos antes, evitando así retrasar o quedarse del recorrido. El transporte otorga un horario de recogida a cada estudiante, no pitara ni esperara; debiendo aclarar que la responsabilidad del señor transportista empieza cuando los estudiantes ingresan al vehículo y finaliza cuando abandonan el mismo.', ".\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'OCTAVA.- ', alignment: 'justify', bold: true }, 'Una vez firmado el presente convenio, el señor padre de familia podrá retirarse del servicio de transporte mediante petición escrita por fuerza mayor justificado o por retirarse definitivamente del Colegio, documento que es necesario para retirar al estudiante en la ruta respectiva y anular este convenio cualquier modificación o retiro deberá solicitarse con anticipación y antes de que concluya el mes que este transcurriendo, a fin de quitar de la información que se envía al banco, caso contrario se aplicara a partir del mes siguiente sin derecho a devolución de los valores cancelados.', ".\n\n"], alignment: 'justify',
            }

            ,
            {
              text: [
                { text: 'NOVENA.- ', alignment: 'justify', bold: true }, 'De producirse problemas anormales en las unidades de transporte, el señor padre de familia deberá presentar oportunamente su reclamo en forma escrita para toma los correctivos necesarios.', ".\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'DECIMA.- ', alignment: 'justify', bold: true }, 'El pago se realizara en 10 meses, utilizando el código de alumno /a del BANCO', ".\n\n"], alignment: 'justify',
            }
            ,
            {
              text: [
                { text: 'DECIMA PRIMERA: DOMICILIO, JURISDICCION Y COMPETENCIA.- ', alignment: 'justify', bold: true }, 'En caso de divergencias y de no resolverse por mutuo acuerdo, Las partes declaran que su domicilio es la Ciudad de Quito y se someten a los jueces competentes del Cantón Quito y al trámite verbal sumario. Para constancia. Las partes suscriben el presente Convenio en el Distrito Metropolitano de Quito a los ', { text: this.dia }, " días del mes de ", { text: this.mes }, " del ", { text: this.anio }, ".\n\n\n\n"], alignment: 'justify',
            },
            {
              columns: [
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: ' Representante operadora UNIÓN\n', alignment: 'center', bold: true },
                    { text: 'RUC: 1790165507001 ', alignment: 'center', bold: true }
                  ]
                },
                {
                  text: [
                    { text: '______________________________\n', alignment: 'center' },
                    { text: 'FIRMA\n', alignment: 'center' },
                    { text: 'Nombre del Represente legal: ' + this.nombreRepresentante + '\n', alignment: 'center', bold: true },
                    { text: 'CI/PASAPORTE:' + this.cedulaRepresentante, alignment: 'center', bold: true }
                  ]
                }


              ]
            },


          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            tableCabecera: {
              bold: true,
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
              alignment: 'center',
            },
            tableExample: {
              margin: [8, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
            // alignment: 'justify'
          }

        }
      }

    }







    if (this.GetMuestraFinal === "CONTRATO") {


      this.descargaPdfUrl = pdfMake.createPdf(pdfDefinition);
      const pdfDocGenerator = pdfMake.createPdf(pdfDefinition);
      pdfDocGenerator.getBuffer((pdfBuffer) => {
        const filePath = 'ContratosFichaInscripcion/' + this.codigoColegioEnviado + "/" + this.cedulaEstudiante;
        const fileRef = this.storage.ref(filePath + '.pdf');
        const task = this.storage.upload(filePath + '.pdf', pdfBuffer.buffer);
        this.uploadPercent = task.percentageChanges();

        task.snapshotChanges().pipe(
          last(),
          switchMap(() => fileRef.getDownloadURL())
        ).subscribe(url => {
          if (url) {
            this.safeSrc = url;
            this.service.EnvioEmail(this.codigoColegioEnviado, this.safeSrc, this.cedulaEstudiante).subscribe(resp => { })
            this.pdfMake = true
          }
        })
      })
    }





  }



  //EJECUTA LA FUNCION PARA EL ENVIO DE EMAIL
  envioServicio() {

    if (this.GetMuestraFinal === "VACIO") {
      this.service.EnvioEmail(this.codigoColegioEnviado, "", this.cedulaEstudiante).subscribe(resp => { });

    }

    else if (this.GetMuestraFinal === "PDF") {
      this.service.EnvioEmail(this.codigoColegioEnviado, this.GetLinkPDF, this.cedulaEstudiante).subscribe(resp => { });
      this.pdfLink = true;

    }




  }



  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);



      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }



  /**********************
   * obtiene los puntos del check si es ruta establecida
   */
  rutasSelecinadas: any[] = [];
  onChange(name: string, isChecked: boolean) {


    const cartoons = (this.DatosServicioTransporteFormGroup.controls.name as UntypedFormArray);

    if (isChecked) {
      cartoons.push(new UntypedFormControl(name));
    } else {
      const index = cartoons.controls.findIndex(x => x.value === name);
      cartoons.removeAt(index);
    }


    this.rutasSelecinadas = cartoons.value.filter(function (x) {
      return x !== null;
    });





  }










  /***********************
 * selecciona ruta establecida
 */


  seleccionRutaEstablecida(data: any) {

    this.rutaPreestablecida = [];
    this.pointse = [];
    this.pointse.push({ element: data.element, nombreRuta: data.nombreRuta, key: data.key });
    this.rutaPreestablecida = data.key;
  }
}


